<template>
  <div class="prices">
    <div class="prices-top">
      <div class="prices-top-iconAndtitle">
        <img
          v-if="levelUrl"
          class="prices-top-iconAndtitle-icon"
          :src="levelUrl"
        />
        <h1 class="prices-top-iconAndtitle-title">
          {{ levelName }} class Memories
        </h1>
      </div>
      <div class="prices-top-progress">
        <div
          class="prices-top-progress-line"
          :style="{ width: divWidth }"
        ></div>
        <div class="prices-top-progress-level">{{ amount }}/5</div>
      </div>
    </div>
    <div class="prices-bottom">
      <div class="prices-bottom-left">
        <img :src="propsUrl" class="prices-bottom-left-propsIcon" />
        <div class="prices-bottom-left-propsName">{{ propsName }}</div>
      </div>
      <img
        v-if="amount === 5"
        class="prices-bottom-gou"
        :src="require('@/assets/images/YuliApp/gou@2x.png')"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    levelName: {
      type: String,
      default: "A",
    },
    levelUrl: {
      type: String,
    },
    propsUrl: {
      type: String,
      default: "A",
    },
    propsName: {
      type: String,
      default: "A",
    },
    amount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      divWidth: "0px",
    };
  },
  watch: {
    amount: {
      handler(value) {
        //收集进度
        if (value === 5) {
          this.divWidth = "100%";
        } else {
          this.divWidth = value * 10 + "px";
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
h1 {
  margin: 0;
  padding: 0;
}
.prices {
  margin: 0 auto;
  width: 287px;
  height: 85px;
  background-image: url("~@/assets/images/YuliApp/block_bg.png");
  background-size: 100% 100%;
  margin-bottom: 2px;
  &-top {
    box-sizing: border-box;
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding-left: 13px;
    padding-right: 15px;
    &-iconAndtitle {
      display: flex;
      align-content: center;
      &-icon {
        width: 24px;
        height: 24px;
        object-fit: cover;
      }
      &-title {
        box-sizing: border-box;
        padding-top: 7.8px;
        margin-left: 5px;
        color: rgba(31, 21, 50, 1);
        font-size: 14px;
        font-weight: 400;
        font-family: "PingFang SC";
        text-align: left;
        line-height: 16.8px;
      }
    }

    &-progress {
      position: relative;
      margin-top: 7.8px;
      width: 50px;
      height: 14px;
      border-radius: 2px;
      border: 1px solid rgba(94, 75, 123, 1);
      background: rgba(57, 47, 76, 1);
      &-line {
        width: 0;
        height: 14px;
        border-radius: 2px;
        background: rgba(75, 110, 130, 1);
      }
      &-level {
        padding-top: 0.5px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: rgba(255, 255, 255, 1);
        font-size: 11px;
        font-weight: 500;
        font-family: "PingFang SC";
        text-align: center;
        line-height: 13.2px;
        letter-spacing: 0.71px;
        opacity: 0.9;
      }
    }
  }
  &-bottom {
    box-sizing: border-box;
    padding: 6.5px 22px 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-left {
      display: flex;
      align-items: center;
      &-propsIcon {
        width: 50px;
        height: 50px;
        object-fit: cover;
        margin-right: 2px;
      }
      &-propsName {
        opacity: 0.8;
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        font-weight: 400;
        font-family: "PingFang SC";
        text-align: left;
        line-height: 16.8px;
      }
    }

    &-gou {
      width: 32px;
      height: 32px;
      object-fit: cover;
    }
  }
}
</style>
